import { jsx as _jsx } from "react/jsx-runtime";
import WithdrawalInfo from "components/WithdrawalInfo";
import { useTxnExpiry } from "./useTxnExpiry";
export function WithdrawalTxnInfo(_a) {
    var info = _a.info;
    var _b = useTxnExpiry(info.expired_at), timeRemaining = _b.timeRemaining, showUnExpiredContent = _b.showUnExpiredContent;
    return (_jsx(WithdrawalInfo, { info: info, timeRemaining: timeRemaining, showUnExpiredContent: showUnExpiredContent }));
}
